import { Link } from "react-router-dom";
import * as icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, PageHero } from "../components/Reveal";
import { SERVICES } from "../data/site";
import useSeo from "../components/Seo";

export default function Services() {
  useSeo("Services", "Heavy cargo, commercial goods, bus and passenger vehicle transportation, project cargo, interstate and dedicated fleet transportation solutions.");
  return (
    <>
      <PageHero
        overline="Our Services"
        lines={[<>Transportation solutions for</>, <>every <em className="italic text-gold-light">load & journey</em></>]}
        desc="Eleven structured service lines, each professionally planned and coordinated. Service availability for specific routes and cargo is confirmed at the time of enquiry."
      />

      <section className="py-24 sm:py-32" data-testid="services-grid-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="grid gap-px border border-gold/15 bg-gold/15 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => {
              const Icon = icons[s.icon] || icons.Truck;
              return (
                <Reveal key={s.title} delay={0.05 * (i % 3)} className="h-full">
                  <article
                    className="group flex h-full flex-col bg-ink p-9 transition-colors duration-500 hover:bg-smoke"
                    data-testid={`service-card-${i}`}
                  >
                    <div className="flex items-start justify-between">
                      <Icon className="h-6 w-6 text-gold transition-colors duration-300 group-hover:text-gold-light" strokeWidth={1.5} />
                      <span className="font-heading text-sm text-gold/70">{String(i + 1).padStart(2, "0")}</span>
                    </div>
                    <h2 className="mt-8 font-heading text-xl leading-snug text-foreground transition-colors duration-300 group-hover:text-gold-light sm:mt-12">
                      {s.title}
                    </h2>
                    <p className="mt-4 flex-1 text-sm leading-[1.8] text-muted-foreground">{s.desc}</p>
                    <Link
                      to="/quote"
                      data-testid={`service-quote-link-${i}`}
                      className="mt-10 inline-flex items-center gap-2 border-t border-gold/10 pt-5 text-[11px] font-semibold uppercase tracking-[0.22em] text-gold transition-colors hover:text-gold-light"
                    >
                      Enquire <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                    </Link>
                  </article>
                </Reveal>
              );
            })}

            <Reveal delay={0.1} className="h-full">
              <Link
                to="/quote"
                data-testid="services-cta-card"
                className="group relative flex h-full min-h-[280px] flex-col justify-between overflow-hidden border-gold/40 p-8"
              >
                <img
                  src="/fleet/jcb-road.webp"
                  alt="The Royal Mahaveer Roadlines equipment on the move"
                  className="absolute inset-0 h-full w-full object-cover opacity-40 transition-transform duration-700 group-hover:scale-105"
                  style={{ filter: "grayscale(0.4) brightness(0.6) sepia(0.25)" }}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/30" />
                <span className="relative font-heading text-sm text-gold/70">12</span>
                <div className="relative">
                  <h2 className="font-heading text-2xl leading-snug text-foreground">Have a different requirement?</h2>
                  <p className="mt-4 text-sm leading-relaxed text-foreground/70">
                    Tell us what needs to move — we will structure a solution around it.
                  </p>
                  <span className="mt-8 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.22em] text-gold transition-colors group-hover:text-gold-light">
                    Request a Quote <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
